import React, { useState, useEffect } from "react";

// Large day / date / time readout shown on the board when there aren't both
// messages and photos to fill the space. 12-hour time with AM/PM, in the
// resident's timezone; ticks every second. Font size comes from the wrapping
// .display-clock element (vh on the room display; an inline px size on the scaled
// caregiver canvas) — the dc-* children size themselves in em off that.
export default function BigClock({ tz }) {
  const [t, setT] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setT(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  const d = new Date(t);
  const o = tz ? { timeZone: tz } : {};
  return (
    <div className="dc-inner">
      <div className="dc-day">{d.toLocaleDateString("en-US", { weekday: "long", ...o })}</div>
      <div className="dc-date">{d.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric", ...o })}</div>
      <div className="dc-time">{d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", ...o })}</div>
    </div>
  );
}
